// Character identities explicitly confirmed by the atelier. Legacy slugs remain
// usable; never derive a customer's displayed name from an old API/cart label.
export const CHARACTER_NAMES = {
  'sylvette-la-crevette': 'Sylvette la Crevette',
  'leon-le-citron': 'Léon le Citron',
  'pralin-le-cornet': 'Pralin le Cornet',
  'pepin-le-sorbet': 'Pépin le Sorbet',
  'camille-la-coquille': 'Camille la Coquille',
  'betty-le-croissant': 'Betty le Croissant',
  'nicolas-le-chocolat': 'Nicolas le Chocolat',
};

// Noms anglais (version /en du site).
export const CHARACTER_NAMES_EN = {
  'sylvette-la-crevette': 'Sylvette the Shrimp',
  'leon-le-citron': 'Léon the Lemon',
  'pralin-le-cornet': 'Pralin the Cone',
  'pepin-le-sorbet': 'Pépin the Sorbet',
  'camille-la-coquille': 'Camille the Shell',
  'betty-le-croissant': 'Betty the Croissant',
  'nicolas-le-chocolat': 'Nicolas the Chocolate',
  'georges-la-feuille': 'Georges the Leaf',
  'clara-le-chat': 'Clara the Cat',
};

const ALIASES = {
  'silvette-la-crevette': 'sylvette-la-crevette',
  'anicet-le-cornet': 'pralin-le-cornet',
  'norbert-le-sorbet': 'pepin-le-sorbet',
  'sybille-la-coquille': 'camille-la-coquille',
};

// Filtre « Personnage » de la boutique : toute la famille, y compris les
// personnages dont la pièce n'est pas encore en ligne.
export const CHARACTER_FILTERS = [
  { slug: 'sylvette-la-crevette', name: 'Sylvette la Crevette' },
  { slug: 'leon-le-citron', name: 'Léon le Citron' },
  { slug: 'camille-la-coquille', name: 'Camille la Coquille' },
  { slug: 'pralin-le-cornet', name: 'Pralin le Cornet' },
  { slug: 'pepin-le-sorbet', name: 'Pépin le Sorbet' },
  { slug: 'betty-le-croissant', name: 'Betty le Croissant' },
  { slug: 'nicolas-le-chocolat', name: 'Nicolas le Chocolat' },
  { slug: 'georges-la-feuille', name: 'Georges la Feuille' },
  { slug: 'clara-le-chat', name: 'Clara le Chat' },
];

// Pastel de chaque personnage (étiquettes, filtres) : classes .pastel--* de index.css.
const CHARACTER_PASTELS = {
  'sylvette-la-crevette': 'rose', 'leon-le-citron': 'beurre', 'camille-la-coquille': 'layette',
  'pralin-le-cornet': 'lilas', 'pepin-le-sorbet': 'menthe', 'betty-le-croissant': 'beurre',
  'nicolas-le-chocolat': 'peche', 'georges-la-feuille': 'menthe', 'clara-le-chat': 'lilas',
};

// Couleurs du catalogue en anglais ; une couleur inconnue garde son nom français.
const COLOR_NAMES_EN = {
  'Corail': 'Coral', 'Jaune Pâle': 'Pale yellow', 'Sauge': 'Sage', 'Crème': 'Cream', 'Miel': 'Honey',
  'Rose Pastel': 'Pastel pink', 'Bleu Ciel': 'Sky blue', 'Jaune': 'Yellow', 'Rose': 'Pink', 'Bleu': 'Blue', 'Vert': 'Green',
};
export const colorName = (name, locale = 'fr') => (locale === 'en' && COLOR_NAMES_EN[name]) || name;

// Une pièce porte le slug de son personnage suivi de sa variante (sylvette-la-crevette-lunettes-vertes).
// Slug d'une pièce sous son nom actuel : seuls les anciens noms changent, la variante est conservée.
export const pieceSlug = slug => ALIASES[slug] || slug;
export const characterSlug = slug => {
  if (ALIASES[slug]) return ALIASES[slug];
  return CHARACTER_FILTERS.find(filter => slug === filter.slug || slug?.startsWith(`${filter.slug}-`))?.slug || slug;
};
// Une pièce par personnage, dans l'ordre du catalogue ; une pièce disponible passe avant une pièce adoptée.
export const onePiecePerCharacter = products => {
  const available = p => !p.made_to_order && p.status !== 'adopted' && p.stock > 0;
  const chosen = new Map();
  for (const product of products) {
    const key = characterSlug(product.slug);
    if (!chosen.has(key) || (!available(chosen.get(key)) && available(product))) chosen.set(key, product);
  }
  return [...chosen.values()];
};
export const pastelClass = slug => `pastel--${CHARACTER_PASTELS[characterSlug(slug)] || 'layette'}`;
export const characterName = (slug, fallback, locale = 'fr') => (
  (locale === 'en' && CHARACTER_NAMES_EN[characterSlug(slug)]) || CHARACTER_NAMES[characterSlug(slug)] || fallback
);
export const characterFilterName = (filter, locale = 'fr') => (locale === 'en' && CHARACTER_NAMES_EN[filter.slug]) || filter.name;

// Textes produit anglais (product.en, fournis par le catalogue du serveur) ; un champ vide garde le français.
const TRANSLATED_FIELDS = ['tagline', 'description', 'material', 'care', 'badge', 'dimensions', 'collection'];
export const withCharacterName = (product, locale = 'fr') => {
  if (!product) return product;
  const translated = {};
  if (locale === 'en' && product.en) {
    TRANSLATED_FIELDS.forEach(field => { if (product.en[field]) translated[field] = product.en[field]; });
  }
  const fallbackName = (locale === 'en' && product.en?.name) || product.name;
  return { ...product, ...translated, name: characterName(product.slug, fallbackName, locale) };
};
